
import { slideUp, slideDown } from './../utility/transition'

const button = document.querySelector('#nav-btn')
const menu = document.querySelector('.site-menu')
const menuBackground = document.querySelector('.site-menu__bg')


let isOpen = false
let timeout = false


function close() {
	isOpen = false
	button.classList.remove('open')
	menu.classList.remove('menu--open')
	menuBackground.classList.remove('open')

	timeout = setTimeout(function() {
        menu.style.display = 'none'
        menuBackground.style.display = 'none'
	}, 500)

	// allow scrolling on html element
	document.documentElement.classList.remove('menu-active')
}


function open() {
	isOpen = true
	clearTimeout(timeout)

	button.classList.add('open')

	// toggle search button state
    menuBackground.style.display = 'block'
	menuBackground.getBoundingClientRect()
	menuBackground.classList.add('open')

	// animate menu in
	menu.style.display = 'flex'
	menu.getBoundingClientRect()
	menu.classList.add('menu--open')

	// stop scrolling on html element
	document.documentElement.classList.add('menu-active')

}


function toggle() {
	isOpen ? close() : open()
}


function submenu(el, link, children) {
	let open = false
	children.style.display = 'none'
	link.addEventListener('click', event => {

		const href = link.getAttribute('href')
		if (href ==='#') { event.preventDefault() }

		if (open) {
			el.classList.remove('open')
			slideUp(children)
			open = false
		} else {
			el.classList.add('open')
			slideDown(children)
			open = true
		}
	})
}

function closeOnLinkClick(el) {
	el.addEventListener('click', event => {
		const href = event.currentTarget.getAttribute('href')
		if (href !=='#' && href.startsWith('#')) close()
	})
}


export function init() {

	if (!button) return
		
	// add event listeners 
	button.addEventListener('click', toggle)
	menuBackground.addEventListener('click', close)

	// submenu dropdown
	const menuEls = [...document.querySelectorAll('.site-menu__item--children')]
	menuEls.map(el => {
		const link = el.querySelector('.site-menu__link')
		const child = el.querySelector('.site-menu__dropdown')
		submenu(el, link, child)
	})

	const allMenuLinks = [...document.querySelectorAll('.site-menu a')]
	allMenuLinks.map(link => closeOnLinkClick(link))

	// detect esc key
	window.addEventListener('keydown', event => {
		const escKey = (event.key === 'Escape' || event.keyCode === 27)
		const isOpen = menu.classList.contains('open')
		if (isOpen && escKey) toggle()
	})	
}
